import RecipeQuantitySelector from './RecipeQuantitySelector';

export default RecipeQuantitySelector;
